import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

export const FilledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.vars?.palette.black.lightest,
  color: theme.vars?.palette.text.secondary,
  '&:hover': {
    backgroundColor: theme.vars?.palette.black.lightest,
  },
  paddingInline: theme.spacing(0.5),
  '& .MuiChip-icon': {
    marginLeft: theme.spacing(1.5),
  },
  '& .MuiChip-label': {
    display: 'flex',
    alignItems: 'center',
  },
}));
